
import { styled } from '@mui/material/styles';

import TableRow from '@mui/material/TableRow';

const StyledTableRow = styled(TableRow, {
    shouldForwardProp: (prop) => !['virtual'].includes(prop),
})(
    ({ theme, virtual }) => ({
        borderBottom: '0 none',
        [virtual?'&.even':'&:nth-of-type(even)']: {
            backgroundColor: theme.palette.background.tablePrimary,
        },
        [virtual?'&.odd':'&:nth-of-type(odd)']: {
            backgroundColor: theme.palette.background.tableSecondary,
        },
        '&.Mui-selected, &.Mui-selected.odd, &.Mui-selected.even': {
            backgroundColor: theme.palette.background.selectedTreeView,
        },
        '&:last-child td': {
            borderBottom: '0 none',
        },
    })
);

export default StyledTableRow;
